import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login';
import templateBuilder from './views/templateBuilder';
import bwtemplateBuilder from './views/bwtemplateBuilder';
import notfound from './views/notfound';
import store from './store/index'
import Callback from './views/auth/callback.vue';

let menu = store.state.modelMenu
let main = menu.filter(x => !x.subs)
let subs = [].concat(...menu.filter(x => x.subs).map(x => x.subs))
let all = main.concat(subs)
let allMapped = all.map(x=>{
  return {
    path: x.path,
    name: x.text,
    component: () => import(`./views/${x.text}`),
  }
})
console.log('------------------------------------');
console.log(all);
console.log('------------------------------------');


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    console.log(to)
    console.log(from)
    //next()
  },
  routes: [
    {
      path: '/login/:magic?',
      name: 'login',
      component: Login,
    },
    {
      path: '/auth/google/callback',
      name: 'socialite_auth_callback',
      component: Callback,
    },
    {
      path: '/template-builder/:template?',
      name: 'template-builder',
      component: templateBuilder,
    },
    {
      path: '/bw-template-builder/:template?',
      name: 'bw-template-builder',
      component: bwtemplateBuilder,
    },
    {
      // will match everything
      path: '*',
      component: notfound,
    }
  ].concat(allMapped)
})

router.beforeEach((to, from, next) => {
  // Special cases that don't require auth
  if (to.name === 'socialite_auth_callback' || to.name === 'login') {
    return next();
  }
  
  // Handle 404 route (path: '*')
  if (to.matched.some(record => record.path === '*')) {
    console.log('Route not found, showing 404 page');
    return next();
  }
  
  let user = store.state.user
  if (user && user.role && to.name != 'login') {
    let a = all.filter(x => x.text == to.name)
    .filter(x => x.roles && x.roles.includes(user.role))
    if ((a && a.length) || to.name != 'login') {
      next()
    } else {
      next({ name: 'login'})
    }
  } else if (!user && to.name != 'login') {
    next({ name: 'login'})
  } else {
    next()
  }
})


Vue.use(Router);

export default router